import { render, staticRenderFns } from "./h5xjh.vue?vue&type=template&id=4889f348&scoped=true"
import script from "./h5xjh.vue?vue&type=script&lang=js"
export * from "./h5xjh.vue?vue&type=script&lang=js"
import style0 from "./h5xjh.vue?vue&type=style&index=0&id=4889f348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889f348",
  null
  
)

export default component.exports